// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

/* eslint-disable no-unused-vars */
import createReducer from '../../../../../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  loading: false,
  bookshopCustomer: {},
  isOpenConfirmModal: false,
  value: '',
  valueStatus: {
    status: true,
    message: null,
  }
};

const customerOverviewReducer = createReducer(initialState, {
  [types.CUSTOMER_OVERVIEW_START_LOADER](state) {
    return {
      ...state,
      loading: true
    };
  },
  [types.CUSTOMER_OVERVIEW_STOP_LOADER](state) {
    return {
      ...state,
      loading: false
    };
  },
  [types.CUSTOMER_OVERVIEW_GET_BOOKSHOP_CUSTOMER_SUCCESS](state, action) {
    return {
      ...state,
      bookshopCustomer: action.payload,
    };
  },
  [types.CUSTOMER_OVERVIEW_CHANGE_REDEEM_VALUE](state, action) {
    return {
      ...state,
      [action.field]: action.value,
      valueStatus: initialState.valueStatus,
    };
  },
  [types.CUSTOMER_OVERVIEW_VALIDATE_REDEEM_VALUE](state, action) {
    return {
      ...state,
      valueStatus: action.payload,
    };
  },
  [types.CUSTOMER_OVERVIEW_RESET_FORM](state) {
    return {
      ...state,
      value: initialState.value,
      valueStatus: initialState.valueStatus,
    };
  },
  [types.CUSTOMER_OVERVIEW_OPEN_CONFIRM_MODAL](state, action) {
    return {
      ...state,
      isOpenConfirmModal: true,
    };
  },
  [types.CUSTOMER_OVERVIEW_CLOSE_CONFIRM_MODAL](state) {
    return {
      ...state,
      isOpenConfirmModal: false
    };
  },
  [types.CUSTOMER_OVERVIEW_REDEEM_VOUCHER_SUCCESS](state, action) {
    return {
      ...state,
      bookshopCustomer: {
        ...state.bookshopCustomer,
        Balance: action.payload,
      }
    };
  },
  [types.CUSTOMER_OVERVIEW_WITHDRAWAL_BALANCE_LOG_SUCCESS](state, action) {
    return {
      ...state,
      bookshopCustomer: {
        ...state.bookshopCustomer,
        BalanceLogs: action.payload
      }
    };
  }
});

export default customerOverviewReducer;
